import {useState} from 'react';
import getAxios from '../../../util/axios/getAxios';
import getFirebaseToken from '../../../util/firebase/getFirebaseToken';

export interface ExportResult {
  count: number;
}

export default function useExportEtsyListingsToGoogleSheet() {
  const [loading, setLoading] = useState(false);

  const exportToSheet = async (linkId: string): Promise<ExportResult> => {
    setLoading(true);
    try {
      const token = await getFirebaseToken();
      if (!token) throw new Error('Not authenticated');
      const response = await getAxios('etsy', {token}).post<ExportResult>('exportEtsyListingsToGoogleSheet', {
        linkId,
      });
      return response.data;
    } finally {
      setLoading(false);
    }
  };

  return [exportToSheet, {loading}] as const;
}
